import React from 'react';
import { Flame, Clock, Sparkles } from 'lucide-react';
export function ProductDetails() {
  const features = [{
    icon: Flame,
    title: 'Clean burn',
    description: 'Food-grade soy wax with a cotton wick for a smooth, even burn.'
  }, {
    icon: Clock,
    title: 'Long lasting',
    description: 'Approximately 65 hours of burn time.'
  }, {
    icon: Sparkles,
    title: 'Smoked Pine',
    description: 'Soft woody notes with subtle warmth, creating a calming atmosphere.'
  }];
  const details = ['Wax type: Food-grade soy', 'Burn time: ~65 hours', 'Scent: Smoked Pine (phthalate-free)', 'Vessel: Gloss black glass', 'Vegan & cruelty-free', 'Hand-poured in England'];
  return <section className="py-24 px-6 border-t border-gray-100" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <h2 className="text-3xl md:text-4xl font-light text-center mb-16" data-id="element-123">
          Why this candle?
        </h2>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-12 mb-16" data-id="element-124">
          {features.map(feature => <div key={feature.title} className="text-center space-y-4" data-id="element-125">
              <div className="flex justify-center" data-id="element-126">
                <feature.icon size={32} strokeWidth={1} className="text-gray-700" data-id="element-127" />
              </div>
              <h3 className="text-lg font-medium" data-id="element-128">{feature.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed font-light" data-id="element-129">
                {feature.description}
              </p>
            </div>)}
        </div>

        {/* Details Card */}
        <div className="max-w-md mx-auto border border-gray-200 p-8 space-y-3" data-id="element-130">
          <h3 className="text-sm tracking-wider mb-4 font-medium" data-id="element-131">DETAILS</h3>
          {details.map((detail, index) => <p key={index} className="text-sm text-gray-600 font-light" data-id="element-132">
              {detail}
            </p>)}
        </div>
      </div>
    </section>;
}